import { forkJoin as observableForkJoin, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Respuesta, TmmvNodo } from '../_models/shared/_index';
import { PlantillaComparacion } from '../_models/informes/plantilla-comparacion';
import {
	PlantillaEvolucionPlano,
	PlantillaEvolucionPrecios,
	PlantillaEvolucionPreciosPorSegmento,
} from '../_models/informes/_index';
import { PlantillaListadoPrecios } from '../_models/informes/plantilla-listado-precios';
import { PlantillaTorreBurbujas } from '../_models/informe-torre-burbujas/plantilla-torre-burbujas';
import { DatosTorreBurbujas } from '../_models/informe-torre-burbujas/datos-torre-burbujas';
import { PlantillaCompetitividadRenault } from '../_models/informes/plantilla-competitividad-renault';
import { PlantillaRangoPrecios } from '../_models/informes/plantilla-rango-precios';
import { PlantillaInforme102030 } from '../_models/informes/plantilla-Informe-102030';
import { PlantillaInformeMMR } from '../_models/informes/plantilla-Informe-MMR';
import { PlantillaInformeCoberturas } from '../_models/informes/plantilla-Informe-coberturas';
import { PlantillaBBCNissan } from '../_models/informes/plantilla-bbc-nissan';
import { PlantillaPVCNissan } from '../_models/informes/plantilla-pvc-nissan';
import { PlantillaBaseDeDatosComparativa } from '../_models/informes/plantilla-base-de-datos-comparativa';
import { PlantillaInformeRevisionDeVersiones } from '../_models/informes/plantilla-informe-revision-versiones';
import { PlantillaInformeConsultaPatentamientos } from '../_models/informes/plantilla-informe-consulta-patentamientos';
import { PlantillaInformeExtraccionDatos } from '../_models/informes/plantilla-Informe-extraccion-datos';
import { ErrorService } from './error.service';
import { PlantillaInformeActividadesUsuario } from '../_models/informes/plantilla-informe-actividades-usuario';
import { PlantillaPsaTools } from '../_models/informes/plantilla-psa-tools';
import { ConfiguracionAnalisisEquipamientoSegmento } from '../_models/informes/configuracion-analisis-equipamiento-segmento';
import { ResultadoAnalisisEquipamientoSegmento } from '../_models/informes/resultados/resultado-analisis-equipamiento-segmento';
import { ExtracionAMedidaReporte } from '../_models/extracciones/extraccion';
import { FiltroMarcadores } from 'app/_models/coberturas/filtro-marcadores';
import { InformeEvolucionBurbujas } from '../_models/informes-wh/evolucion-burbujas/informe-evolucion-burbujas';
import { FiltroVersion } from '../_models/shared/filtro-version';
import { FiltroRegionesVolumen } from '../_models/redes-concesionarios/filtro-regiones-volumen';
import { ParametrosControlPrecios } from '../_models/informe-control-carga-precios/parametros-control-precios';
//import { PlantillaPosicionamientoPrecios } from '../_models/informes/plantilla-posicionamiento-precios';

@Injectable()
export class InformesService {
	constructor(private http: HttpClient, private errorService: ErrorService) {}

	//#region  Get de datos
	private getSegmentacionesUrl: string =
		environment.rest + '/Informes/GetSegmentaciones';
	private getSegmentacionByIdUrl: string =
		environment.rest + '/Informes/GetSegmentacionById';
	private getSegmentacionesPorNodosUrl: string =
		environment.rest + '/Informes/GetSegmentacionesPorNodos';
	private getSegmentacionesPorIdsNodosUrl: string =
		environment.rest + '/Informes/GetSegmentacionesPorIdsNodos';
	private getFormulasUrl: string = environment.rest + '/Informes/GetFormulas';
	private getMonedasUrl: string = environment.rest + '/Informes/GetMonedas';
	private getPlantillasTreeUrl: string =
		environment.rest + '/Informes/GetPlantillasTree';
	private getIdiomasUrl: string = environment.rest + '/Informes/GetIdiomas';
	private getCodificacionesDefaultUrl: string =
		environment.rest + '/Informes/GetCodificacionesDefault';
	private getAtributosDefaultUrl: string =
		environment.rest + '/Informes/GetAtributosDefault';
	private getValorizacionesUrl: string =
		environment.rest + '/Informes/GetValorizaciones';
	private getVariablesUrl: string =
		environment.rest + '/Informes/GetVariables';
	private getCamposExtraccionUrl: string =
		environment.rest + '/Informes/GetCamposExtraccion';
	private getInformesGeneradosUrl: string =
		environment.rest + '/Informes/GetInformesGenerados';
	private getInformeTorreBurbujasDataUrl: string =
		environment.rest + '/Informes/GetInformeTorreBurbujasData';
	private getFormulaBonificacionPrecioSeleccionadaUrl: string =
		environment.rest + '/Informes/GetFormulaBonificacionPrecioSeleccionada';
	private getSegmentacionDefaultByValorizacionUrl: string =
		environment.rest + '/Informes/GetSegmentacionDefaultByValorizacion';
	private getFormulaBonificacionCalculadaSeleccionadaUrl: string =
		environment.rest +
		'/Informes/GetFormulaBonificacionCalculadaSeleccionada';
	private getCodificacionSeleccionadaUrl: string =
		environment.rest + '/Informes/GetCodificacionSeleccionada';
	private getValorizacionSeleccionadaUrl: string =
		environment.rest + '/Informes/GetValorizacionSeleccionada';
	private guardarVariablesLocalesUrl: string =
		environment.rest + '/VariablesLocales/guardarVariablesLocales';
	private getSubversionesBySegmentacionUrl: string =
		environment.rest + '/Informes/GetSubversionesBySegmentacion';
	private getNodosSegmentacionesUrl: string =
		environment.rest + '/Informes/GetNodosSegmentaciones';
	private getDatosTorreBurbujasModelConAtributosUrl: string =
		environment.rest + '/Atributos/GetDatosTorreBurbujasModelConAtributos';
	private getValorizacionesConTraducibleUrl: string =
		environment.rest + '/Informes/GetValorizacionesConTraducible';
	private getTiposInformeUrl: string =
		environment.rest + '/Informes/GetTiposInforme';
	private exportarInformeAnalisisDeEquipamientoPorSegmentoUrl: string =
		environment.rest +
		'/Informes/ExportarInformeAnalisisDeEquipamientoPorSegmento';
	private exportarInformeAnalisisDeEquipamientoPorMutiplesSegmentosUrl: string =
		environment.rest +
		'/Informes/ExportarInformeAnalisisDeEquipamientoPorMultiplesSegmentos';
	private getConfigArbolUrl: string =
		environment.rest + '/Informes/GetUsaArbolPropio';
	private getDatosFuenteInformeControlPreciosUrl: string =
		environment.rest + '/Informes/GetDatosFuenteInformeControlPrecios';
	private getDatosMarcasInformeControlPreciosUrl: string =
		environment.rest + '/Informes/GetDatosMarcasInformeControlPrecios';
	//#endregion

	//#region Generadores de informes
	private generarInformeComparacionUrl: string =
		environment.rest + '/Informes/GenerarInformeComparacion';
	private generarInformeCompetitividadUrl: string =
		environment.rest + '/Informes/GenerarInformeCompetitividadRenault';
	private generarInformeEvolucionPlanoUrl: string =
		environment.rest + '/Informes/GenerarInformeEvolucionPlano';
	private generarInformeEvolucionPlanoExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeEvolucionPlanoExcel';
	private generarInformeComparacionExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeComparacionExcel';
	private generarInformeCompetitividadExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeCompetitividadRenaultExcel';
	private generarInformeRevisionVersionesUrl: string =
		environment.rest + '/Informes/GenerarInformeRevisionVersiones';
	private generarInformeEvolucionPreciosExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeEvolucionPreciosExcel';
	private generarInformeEvolucionPreciosUrl: string =
		environment.rest + '/Informes/GenerarInformeEvolucionPrecios';
	private generarInformeEvolucionPreciosPorSegmentoExcelUrl: string =
		environment.rest +
		'/Informes/GenerarInformeEvolucionPreciosPorSegmentoExcel';
	private generarInformeEvolucionPreciosPorSegmentoUrl: string =
		environment.rest +
		'/Informes/GenerarInformeEvolucionPreciosPorSegmento';
	private generarInformeRangoPreciosExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeRangoPreciosExcel';
	private generarInformeListadoPreciosExcelUrl: string =
		environment.rest + '/Informes/GenerarListadoPreciosExcel';
	private generarInformeListadoPreciosUrl: string =
		environment.rest + '/Informes/GenerarListadoPrecios';
	private generarInformeTorreBurbujasExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeTorreBurbujasExcel';
	private generarInformePriceLadderDinamicoUrl: string =
		environment.rest + '/Informes/GenerarInformePriceLadderDinamico';
	private generarInformeExtraccionDatosUrl: string =
		environment.rest + '/Informes/GenerarInformeExtraccionDatos';
	private generarInforme102030ExcelUrl: string =
		environment.rest + '/Informes/GenerarInforme102030Excel';
	private generarInformeMMRExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeMMRExcel';
	private generarInformeCoberturasExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeCoberturasExcel';
	private generarInformeBbcNissanExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeBBCNissanExcel';
	private generarInformePvcNissanExcelUrl: string =
		environment.rest + '/Informes/GenerarInformePVCNissanExcel';
	private generarInformeBaseDeDatosComparativaExcelUrl: string =
		environment.rest +
		'/Informes/GenerarInformeBaseDeDatosComparativaExcel';
	private generarInformeEstudioDePreciosExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeEstudioDePreciosExcel';
	private generarInformeConsultaPatentamientosUrl: string =
		environment.rest + '/Informes/GenerarInformeConsultaPatentamientos';
	private generarInformePosicionamientoPreciosExcelUrl: string =
		environment.rest +
		'/Informes/GenerarInformePosicionamientoPreciosExcel';
	private generarInformePsaToolsUrl: string =
		environment.rest + '/Informes/GenerarInformePsaTools';
	private generarInformeActividadesUsuarioUrl: string =
		environment.rest + '/Informes/GenerarInformeActividadesUsuario';
	private generarInformeAnalisisDeEquipamientoPorSegmentoUrl: string =
		environment.rest +
		'/Informes/GenerarInformeAnalisisDeEquipamientoPorSegmento';
	private generarInformeAnalisisDeEquipamientoPorMutiplesSegmentosUrl: string =
		environment.rest +
		'/Informes/GenerarInformeAnalisisDeEquipamientoPorMultiplesSegmentos';
	private generarInformeExtraccionDeLocacionesUrl: string =
		environment.rest + '/Informes/GenerarInformeExtraccionDeLocaciones';
	private generarInformeExtraccionSPOUrl: string =
		environment.rest + '/Informes/GenerarInformeSPONissan';
	private generarInformeExtraccionSPPUrl: string =
		environment.rest + '/Informes/GenerarInformeSPPNissan';
	private reporteArmarComparacionMaterialUrl: string =
		environment.rest + '/Informes/GenerarReporteComparacionMaterial';
	private generarInformeExtraccionAMedidaUrl: string =
		environment.rest + '/Informes/GenerarInformeExtraccionAMedida';
	private generarInformeCTTDinamicoUrl: string =
		environment.rest + '/Informes/GenerarInformeCTTDinamico';
	private generarInformeCTTExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeCTTExcel';
	private generarInformeCoberturasMapaNuevoUrl: string =
		environment.rest + '/Informes/GenerarInformeCoberturasMapaNuevo';

	private getInformeEvolucionBurbujasDataUrl: string =
		environment.rest + '/Informes/GetInformeEvolucionBurbujasData';

	private getVersionesSimpleByClasificacionesUrl: string =
		environment.rest + '/Informes/GetVersionesSimpleByClasificaciones';

	private getSegmentacionesSimpleByClasificacionesUrl: string =
		environment.rest + '/Informes/GetSegmentacionesSimpleByClasificaciones';

	private getModelosSimpleUrl: string =
		environment.rest + '/Informes/GetModelosSimple';

	private generarInformeEvolucionBurbujasExcelUrl: string =
		environment.rest + '/Informes/GenerarInformeEvolucionBurbujasExcel';

	//#endregion

	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	public generarInformeCTTDinamico(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.generarInformeCTTDinamicoUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get generarInformeCTTDinamico`
					)
				)
			);
	}

	public generarInformeCTTExcel(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.generarInformeCTTExcelUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get generarInformeCTTExcel`
					)
				)
			);
	}

	public generarInformeCoberturasMapaNuevo(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.generarInformeCoberturasMapaNuevoUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get generarInformeCoberturasMapaNuevo`
					)
				)
			);
	}

	public getSegmentaciones(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getSegmentacionesUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getSegmentaciones`
					)
				)
			);
	}

	public getSegmentacionById(idSegmentacion: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getSegmentacionByIdUrl,
				{ idSegmentacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getSegmentacionById`
					)
				)
			);
	}

	public getSegmentacionesPorNodos(
		nodos: Array<TmmvNodo>,
		idSegmentacion: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getSegmentacionesPorNodosUrl,
				{ nodos, idSegmentacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getSegmentacionesPorNodos`
					)
				)
			);
	}

	public getSegmentacionesPorIdsNodos(
		idsClasificaciones: number[],
		idsVersiones: number[],
		idSegmentacion: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getSegmentacionesPorIdsNodosUrl,
				{ idsClasificaciones, idsVersiones, idSegmentacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getSegmentacionesPorIdsNodos`
					)
				)
			);
	}

	public getFormulas(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getFormulasUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get getFormulas`)
			)
		);
	}

	public getMonedas(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getMonedasUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get getMonedas`)
			)
		);
	}

	public getCodificaciones(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getCodificacionesDefaultUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getCodificaciones`
					)
				)
			);
	}

	public getPlantillasByIdInforme(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getPlantillasTreeUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getPlantillasTree`
					)
				)
			);
	}

	public getIdiomas(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getIdiomasUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get getIdiomas`)
			)
		);
	}

	public getCodificacionesDefault(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getCodificacionesDefaultUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getCodificacionesDefault`
					)
				)
			);
	}

	public getAtributosDefault(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getAtributosDefaultUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getAtributosDefaultUrl`
					)
				)
			);
	}

	public getValorizaciones(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getValorizacionesUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getValorizaciones`
					)
				)
			);
	}
	public getValorizacionesConTraducible(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getValorizacionesConTraducibleUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getValorizacionesConTraducible`
					)
				)
			);
	}

	//gdrive
	public generarInformeComparacion(
		informe: PlantillaComparacion,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeComparacionUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeComparacion`
					)
				)
			);
	}

	public generarInformeRevisionVersiones(
		informe: PlantillaInformeRevisionDeVersiones,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeRevisionVersionesUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeRevisionVersiones`
					)
				)
			);
	}

	public generarInformeCompetitividad(
		informe: PlantillaCompetitividadRenault,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeCompetitividadUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeCompetitividad`
					)
				)
			);
	}

	public generarInformeEvolucionPrecios(
		informe: PlantillaEvolucionPrecios,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionPreciosUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEvolucionPrecios`
					)
				)
			);
	}

	public generarInformeEvolucionPreciosPorSegmento(
		informe: PlantillaEvolucionPreciosPorSegmento,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionPreciosPorSegmentoUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEvolucionPreciosPorSegmento`
					)
				)
			);
	}

	public getVariables(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getVariablesUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get getVariables`)
			)
		);
	}

	public getCamposExtraccion(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getCamposExtraccionUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getCamposExtraccion`
					)
				)
			);
	}

	public generarInformeEvolucionPlano(
		informe: PlantillaEvolucionPlano,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionPlanoUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEvolucionPlano`
					)
				)
			);
	}

	public generarInformeListadoPrecios(
		informe: PlantillaListadoPrecios,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeListadoPreciosUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeListadoPrecios`
					)
				)
			);
	}

	public getInformesGenerados(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getInformesGeneradosUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getInformesGenerados`
					)
				)
			);
	}

	public getFormulaBonificacionPrecioSeleccionada(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(
				this.getFormulaBonificacionPrecioSeleccionadaUrl,
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getFormulaBonificacionPrecioSeleccionada`
					)
				)
			);
	}

	public getSegmentacionDefaultByValorizacion(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(
				this.getSegmentacionDefaultByValorizacionUrl,
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getSegmentacionDefaultByValorizacion`
					)
				)
			);
	}

	public getInformeTorreBurbujasData(
		informe: PlantillaTorreBurbujas
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getInformeTorreBurbujasDataUrl,
				{ informe },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getInformeTorreBurbujasData`
					)
				)
			);
	}

	public getInformeTorreBurbujasDataChunks(
		chunks: PlantillaTorreBurbujas[],
		incluirAtributos: boolean
	): Observable<any[]> {
		let respuestas: any[] = [];
		let options = { headers: this.headers, withCredentials: true };

		chunks.forEach((informe) => {
			let respuesta = this.http
				.post<Respuesta>(
					this.getInformeTorreBurbujasDataUrl,
					{ informe, incluirAtributos },
					options
				)
				.pipe(
					tap((res) => {
						this.errorService.CheckResponse(res);
					}),
					catchError(
						this.errorService.handleError<Respuesta>(
							`POST getInformeTorreBurbujasDataChunks`
						)
					)
				);
			respuestas.push(respuesta);
		});

		return observableForkJoin(respuestas);
	}

	public getFormulaBonificacionCalculadaSeleccionada(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(
				this.getFormulaBonificacionCalculadaSeleccionadaUrl,
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getFormulaBonificacionCalculadaSeleccionada`
					)
				)
			);
	}

	public getValorizacionSeleccionada(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getValorizacionSeleccionadaUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getValorizacionSeleccionada`
					)
				)
			);
	}

	public getCodificacionSeleccionada(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.getCodificacionSeleccionadaUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getCodificacionDefaultSeleccionada`
					)
				)
			);
	}

	public guardarVariablesLocales(
		valorBonificacionPrecio: number,
		valorBonificacionCalculada: number,
		valorValorizacion: number,
		valorCodificacion: number,
		usaArbolPropio: boolean
	): Observable<Respuesta> {
		let options = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			withCredentials: true,
		};
		return this.http
			.post<Respuesta>(
				this.guardarVariablesLocalesUrl,
				{
					valorBonificacionPrecio,
					valorBonificacionCalculada,
					valorValorizacion,
					valorCodificacion,
					usaArbolPropio,
				},
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> guardarVariablesLocales`
					)
				)
			);
	}

	public getNodosSegmentaciones(
		idSegmentacion: number
	): Observable<Respuesta> {
		let options = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			withCredentials: true,
		};
		return this.http
			.post<Respuesta>(
				this.getNodosSegmentacionesUrl,
				{ idSegmentacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getNodosSegmentaciones`
					)
				)
			);
	}

	public getSubversionesBySegmentacion(
		idsFiltroSegmentacion: number[],
		minProfundidad: number,
		maxProfundidad: number,
		incluirDiscontinuadas: boolean
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getSubversionesBySegmentacionUrl,
				{
					idsFiltroSegmentacion,
					minProfundidad,
					maxProfundidad,
					incluirDiscontinuadas,
				},
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getSubversionesBySegmentacion`
					)
				)
			);
	}

	public getDatosTorreBurbujasModelConAtributos(
		informe: DatosTorreBurbujas[],
		idIdioma: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getDatosTorreBurbujasModelConAtributosUrl,
				{ informe, idIdioma },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getDatosTorreBurbujasModelConAtributos`
					)
				)
			);
	}

	public getDatosTorreBurbujasModelConAtributosChunks(
		chunks: DatosTorreBurbujas[],
		idIdioma: number
	): Observable<any[]> {
		let respuestas: any[] = [];
		let options = { headers: this.headers, withCredentials: true };

		chunks.forEach((informe) => {
			let respuesta = this.http
				.post<Respuesta>(
					this.getDatosTorreBurbujasModelConAtributosUrl,
					{ informe, idIdioma },
					options
				)
				.pipe(
					tap((res) => {
						this.errorService.CheckResponse(res);
					}),
					catchError(
						this.errorService.handleError<Respuesta>(
							`POST getDatosTorreBurbujasModelConAtributosChunks`
						)
					)
				);
			respuestas.push(respuesta);
		});

		return observableForkJoin(respuestas);
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}

	public generarInformeComparacionExcel(
		informe: PlantillaComparacion,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeComparacionExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeComparacion`
					)
				)
			);
	}

	public generarInformeCompetitividadExcel(
		informe: PlantillaCompetitividadRenault,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeCompetitividadExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeCompetitividadExcel`
					)
				)
			);
	}

	public generarInformeEvolucionPreciosExcel(
		informe: PlantillaEvolucionPrecios,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionPreciosExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEvolucionPrecios en excel`
					)
				)
			);
	}

	public generarInformeEvolucionPreciosPorSegmentoExcel(
		informe: PlantillaEvolucionPreciosPorSegmento,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionPreciosPorSegmentoExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEvolucionPreciosPorSegmento en excel`
					)
				)
			);
	}

	public generarInformeRangoPreciosExcel(
		informe: PlantillaRangoPrecios,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeRangoPreciosExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeRangoPrecios en excel`
					)
				)
			);
	}

	public generarInformeEvolucionPlanoExcel(
		informe: PlantillaEvolucionPlano,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionPlanoExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEvolucionPlanoExcel`
					)
				)
			);
	}

	public generarInformeListadoPreciosExcel(
		informe: PlantillaListadoPrecios,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeListadoPreciosExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeListadoPreciosExcel`
					)
				)
			);
	}

	public generarInformeListadoPreciosExcelChunks(
		chunks: PlantillaListadoPrecios[],
		nombreArchivo: String
	): Observable<any[]> {
		let respuestas: any[] = [];
		let options = { headers: this.headers, withCredentials: true };

		chunks.forEach((informe) => {
			let respuesta = this.http
				.post<Respuesta>(
					this.generarInformeListadoPreciosExcelUrl,
					{ informe, nombreArchivo },
					options
				)
				.pipe(
					tap((res) => {
						this.errorService.CheckResponse(res);
					}),
					catchError(
						this.errorService.handleError<Respuesta>(
							`POST generarInformeListadoPreciosExcelChunks`
						)
					)
				);
			respuestas.push(respuesta);
		});

		return observableForkJoin(respuestas);
	}

	public generarInformeTorreBurbujasExcel(
		informe: PlantillaTorreBurbujas,
		datos: DatosTorreBurbujas[]
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeTorreBurbujasExcelUrl,
				{ informe, datos },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeTorreBurbujasExcel`
					)
				)
			);
	}

	public registrarInformeGeneradoPriceLadderDinamico(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.generarInformePriceLadderDinamicoUrl, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get generarInformePriceLadderDinamico`
					)
				)
			);
	}

	public generarInformeExtraccionDatos(
		informe: PlantillaInformeExtraccionDatos
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeExtraccionDatosUrl,
				{ informe },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeExtraccionDatos`
					)
				)
			);
	}

	public generarInforme102030Excel(
		informe: PlantillaInforme102030,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInforme102030ExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInforme102030Excel`
					)
				)
			);
	}

	public generarInformeMMRExcel(
		informe: PlantillaInformeMMR,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeMMRExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeMMRExcel`
					)
				)
			);
	}

	public generarInformeCoberturasExcel(
		informe: PlantillaInformeCoberturas,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeCoberturasExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeCoberturasExcel`
					)
				)
			);
	}

	public generarInformeBbcNissanExcel(
		informe: PlantillaBBCNissan,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeBbcNissanExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeBbcNissanExcel`
					)
				)
			);
	}

	public generarInformePvcNissanExcel(
		informe: PlantillaPVCNissan,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformePvcNissanExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformePvcNissanExcel`
					)
				)
			);
	}

	public generarInformeBaseDeDatosComparativaExcel(
		informe: PlantillaBaseDeDatosComparativa,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeBaseDeDatosComparativaExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeBaseDeDatosComparativaExcel`
					)
				)
			);
	}

	public generarInformeEstudioDePreciosExcel(
		informe: PlantillaBaseDeDatosComparativa,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEstudioDePreciosExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeEstudioDePreciosExcel`
					)
				)
			);
	}

	public generarInformeConsultaPatentamientos(
		informe: PlantillaInformeConsultaPatentamientos,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeConsultaPatentamientosUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeConsultaPatentamientos`
					)
				)
			);
	}

	public generarInformeActividadesUsuario(
		informe: PlantillaInformeActividadesUsuario,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeActividadesUsuarioUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeActividadesUsuario`
					)
				)
			);
	}

	public generarInformePsaTools(
		informe: PlantillaPsaTools,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformePsaToolsUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformePsaTools`
					)
				)
			);
	}

	public GenerarInformeAnalisisDeEquipamientoPorSegmento(
		configuracion: ConfiguracionAnalisisEquipamientoSegmento
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeAnalisisDeEquipamientoPorSegmentoUrl,
				{ configuracion: configuracion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post GenerarInformeAnalisisDeEquipamientoPorSegmento`
					)
				)
			);
	}
	public GenerarInformeExtraccionAMedida(
		configuracion: ExtracionAMedidaReporte,
		nombreArchivo: String
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeExtraccionAMedidaUrl,
				{ configuracion, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post GenerarInformeExtraccionAMedida`
					)
				)
			);
	}

	public GenerarInformeExtraccionDeLocaciones(
		configuracion: FiltroMarcadores
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeExtraccionDeLocacionesUrl,
				{ configuracion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeExtraccionDeLocacionesUrl`
					)
				)
			);
	}

	public GenerarInformeExtraccionSPO(
		filtroMarcadores: FiltroMarcadores,
		filtroVolumen: FiltroRegionesVolumen
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeExtraccionSPOUrl,
				{ filtroMarcadores, filtroVolumen },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeExtraccionDeLocacionesUrl`
					)
				)
			);
	}

	public GenerarInformeExtraccionSPP(
		filtroMarcadores: FiltroMarcadores,
		filtroVolumen: FiltroRegionesVolumen
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeExtraccionSPPUrl,
				{ filtroMarcadores, filtroVolumen },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarInformeExtraccionDeLocacionesUrl`
					)
				)
			);
	}

	public ExportarInformeAnalisisDeEquipamientoPorSegmento(
		configuracion: ConfiguracionAnalisisEquipamientoSegmento,
		resultado: ResultadoAnalisisEquipamientoSegmento,
		nombreArchivo: string
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.exportarInformeAnalisisDeEquipamientoPorSegmentoUrl,
				{
					configuracion: configuracion,
					resultado: resultado,
					nombreArchivo: nombreArchivo,
				},
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post GenerarInformeAnalisisDeEquipamientoPorSegmento`
					)
				)
			);
	}

	public getTiposInforme(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getTiposInformeUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get getTiposInforme`)
			)
		);
	}

	public reporteArmarComparacionMaterial(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.reporteArmarComparacionMaterialUrl,
				{},
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post reporteArmarComparacionMaterial`
					)
				)
			);
	}

	public getConfigArbol(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getConfigArbolUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get getConfigArbol`)
			)
		);
	}

	public getInformeEvolucionBurbujasData(
		informe: InformeEvolucionBurbujas
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getInformeEvolucionBurbujasDataUrl,
				{ informe },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getInformeEvolucionBurbujasData`
					)
				)
			);
	}

	public getVersionesSimpleByClasificaciones(
		idsClasificaciones: number[],
		filtro: FiltroVersion
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getVersionesSimpleByClasificacionesUrl,
				{ idsClasificaciones, filtro },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getNombresVersiones`
					)
				)
			);
	}

	public getSegmentacionesSimpleByClasificaciones(
		idsClasificaciones: number[],
		filtro: FiltroVersion
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getSegmentacionesSimpleByClasificacionesUrl,
				{ idsClasificaciones, filtro },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getNombresSegmentaciones`
					)
				)
			);
	}

	public getModelosSimple(
		idsClasificaciones: number[],
		filtro: FiltroVersion
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getModelosSimpleUrl,
				{ idsClasificaciones, filtro },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getModelosSimple`
					)
				)
			);
	}

	public generarInformeEvolucionBurbujasExcel(
		informe: InformeEvolucionBurbujas,
		nombreArchivo: string = ''
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.generarInformeEvolucionBurbujasExcelUrl,
				{ informe, nombreArchivo },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getInformeEvolucionBurbujasData`
					)
				)
			);
	}

	public getDatosFuenteInformeControlPrecios(
		parametros: ParametrosControlPrecios
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getDatosFuenteInformeControlPreciosUrl,
				{ parametros },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getDatosInformeControlPrecios`
					)
				)
			);
	}

	public getDatosMarcaInformeControlPrecios(
		parametros: ParametrosControlPrecios
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getDatosMarcasInformeControlPreciosUrl,
				{ parametros },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getDatosInformeControlPrecios`
					)
				)
			);
	}

	// public generarInformePosicionamientoPreciosExcel(informe: PlantillaPosicionamientoPrecios, nombreArchivo: string): Observable<Respuesta> {
	//     let options = { headers: this.headers, withCredentials: true };
	//     return this.http.post<Respuesta>(this.generarInformePosicionamientoPreciosExcelUrl, { informe, nombreArchivo }, options).pipe(
	//         tap(res => {
	//             this.errorService.CheckResponse(res);
	//         }),
	//         catchError(this.errorService.handleError<Respuesta>(`post generarInformePosicionamientoPreciosExcel`))
	//     );
	// }
}
